module.exports = __webpack_public_path__ + "static/media/icon-house.4e86913a.svg";